export const main = {
  width: "100vw",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  backgroundColor: "#f2f2f2",
  padding: "1px 0 40px",
};

export const link = {
  width: "100%",
  textDecoration: "none",
};

export const modal = {
  width: "100vw",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "rgba(150, 150, 150, 0.6)",
  zIndex: 6,
  position: "fixed",
  top: 0,
};

export const modalItem = {
  width: "100%",
  height: "50%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "whitesmoke",
  borderRadius: "15px 15px 0 0",
  zIndex: 9,
  // boxShadow: "1px 1px 7px 1px rgba(50, 50, 50, 0.6)",
};

export const divButton = {
  width: "100vw",
  height: "50%",
  backgroundColor: "rgba(150, 150, 150, 0)",
  zIndex: 7,
  border: 0,
};

export const walletOptions = {
  width: "100%",
  display: "flex",
  justifyContent: "left",
  alignItems: "center",
  margin: "10px 10px",
};

export const walletContainer = {
  width: "90%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "whitesmoke",
};
